<ng-container *ngIf="type === GlobalSearchType.PAGE">
  <div class="global-search global-search--page">
    <div class="global-search--page__headline">
      <div class="global-search--page__headline__offset"></div>
      <div class="global-search--page__headline__text">
        <h1>{{ globalHeadline }}</h1>
        <h2>{{ founded }} Treffer</h2>
      </div>
    </div>
    <div class="global-search--page__content">
      <div class="global-search--page__content__filter-box">
        <div class="global-search--page__content__filter-box__category">
          <p><strong>Inhalte für</strong></p>
          <hdi-radio-group [multiSelectable]="false" [orientation]="'vertical'">
            <hdi-radio
              label="Geschäftskunden"
              value="Geschäftskunden"
            ></hdi-radio>
            <hdi-radio label="Privatkunden" value="Privatkunden"></hdi-radio>
            <hdi-radio label="Alle anzeigen" value="Alle anzeigen"></hdi-radio>
          </hdi-radio-group>
        </div>
        <div class="global-search--page__content__filter-box__category">
          <p><strong>Rubrik</strong></p>
          <hdi-radio-group [multiSelectable]="false" [orientation]="'vertical'">
            <hdi-radio
              [radioType]="RadioType.SQUARED"
              label="Geschäftskunden"
              value="Geschäftskunden"
            ></hdi-radio>
            <hdi-radio
              [radioType]="RadioType.SQUARED"
              label="Privatkunden"
              value="Privatkunden"
            ></hdi-radio>
            <hdi-radio
              [radioType]="RadioType.SQUARED"
              label="Alle anzeigen"
              value="Alle anzeigen"
            ></hdi-radio>
          </hdi-radio-group>
        </div>
      </div>
      <div
        class="global-search--page__content__inpage-search-section global-search--page__content__inpage-search-section--desktop"
      >
        <hdi-inpage-search
          [placeholder]="searchPlaceholder"
          [searchGroup]="searchGroup"
          [buttonType]="buttonType.PRIMARY"
          [CTA]="true"
          [labelCTA]="labelCTA | capitalize"
        ></hdi-inpage-search>
        <div
          class="global-search--page__content__inpage-search-section__result"
        >
          <h4>Ihre Suche hat keine Treffer ergeben</h4>
          <p>
            Wir würden uns freuen, Ihnen helfen zu können. Wenden Sie sich gerne
            per E-Mail an uns.
          </p>
          <div
            class="global-search--page__content__inpage-search-section__result__cards"
          >
            <hdi-card
              *ngFor="let card of cards"
              [icon]="card.icon"
              [title]="card.title"
              [textLink]="card.textLink"
              [link]="card.link"
              [linkType]="card.linkType"
              [date]="card.date"
              [subtitle]="card.subtitle"
              [disabled]="card.disabled"
              [iconColor]="card.iconColor"
              [linkTarget]="card.linkTarget"
            ></hdi-card>
          </div>
        </div>
      </div>
      <div
        class="global-search--page__content__inpage-search-section global-search--page__content__inpage-search-section--mobile"
      >
        <hdi-inpage-search
          [placeholder]="searchPlaceholder"
          [searchGroup]="searchGroup"
          [buttonType]="buttonType.PRIMARY_ICON"
          [CTA]="true"
          [labelCTA]="''"
          [buttonIcon]="'search'"
        ></hdi-inpage-search>
        <div
          class="global-search--page__content__inpage-search-section__result"
        >
          <h4>Ihre Suche hat keine Treffer ergeben</h4>
          <p>
            Wir würden uns freuen, Ihnen helfen zu können. Wenden Sie sich gerne
            per E-Mail an uns.
          </p>
          <div
            class="global-search--page__content__inpage-search-section__result__cards"
          >
            <hdi-card
              *ngFor="let card of cards"
              [icon]="card.icon"
              [title]="card.title"
              [textLink]="card.textLink"
              [link]="card.link"
              [linkType]="card.linkType"
              [date]="card.date"
              [subtitle]="card.subtitle"
              [disabled]="card.disabled"
              [iconColor]="card.iconColor"
              [linkTarget]="card.linkTarget"
            ></hdi-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === GlobalSearchType.BAR">
  <div class="global-search global-search--bar">
    <div class="container">
      <hdi-inpage-search
        [placeholder]="searchPlaceholder"
        [searchGroup]="searchGroup"
      ></hdi-inpage-search>
    </div>
  </div>
</ng-container>
